import { InjectionToken } from '@angular/core';

import { BetslipModuleLoaderService } from './betslip-module-loader.service';
import { IOddsSettingsService } from './services/odds-settings.service';

export const BETSLIP_MODULE_LOADER_SERVICE = new InjectionToken<BetslipModuleLoaderService>('Betslip module loader token');

/* Services */

export const ODDS_SETTINGS_SERVICE = new InjectionToken<IOddsSettingsService>('BET_STATION_ODDS_SETTINGS_SERVICE');

export const ODDS_VIEW_MODE = new InjectionToken<boolean>('ODDS_VIEW_MODE');
